// 操作 Tips パネルの開閉状態を localStorage に保存する。

const KEY = "refinement-canvas:tips:collapsed";

export function loadTipsCollapsed(): boolean {
  try {
    // 既定は折りたたみ（非表示）。明示的に展開("0")を保存した場合のみ展開で開始する。
    // 不正値や localStorage 例外時も既定（折りたたみ）へフォールバックする。
    return window.localStorage.getItem(KEY) !== "0";
  } catch {
    return true;
  }
}

export function saveTipsCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(KEY, collapsed ? "1" : "0");
  } catch {
    // ignore
  }
}
